import React from "react";
import { Box, Typography } from "@material-ui/core";

const boxProps = {
  bgcolor: "background.paper",
  m: 1,
  borderColor: "text.primary",
};

export default function EntryTacticSummaryBox({
  marketOrder,
  candleBreak,
  limitOrder,
}) {
  let marketOrderText = "";
  let limitOrderText = "";
  let candleBreakText = "";
  if (marketOrder !== undefined) {
    marketOrderText = (
      <>
        <b>market order</b>: qtyBasisValue: {marketOrder.quantityBasisValue}
        <br />
      </>
    );
  }
  if (limitOrder !== undefined) {
    limitOrderText = (
      <>
        <b>limit order</b>: qtyBasisValue: {limitOrder.quantityBasisValue}
        <br />
        set limit from setup: {limitOrder.setLimitFromSetupBreakPrice}
        <br />
        offset: {limitOrder.offsetFromSetupPrice}
        limitPrice: {limitOrder.limitPrice}
      </>
    );
  }
  if (candleBreak !== undefined) {
    candleBreakText = (
      <>
        <b>candle break</b>: qtyBasisValue: {candleBreak.quantityBasisValue}.
        candleDuration: {candleBreak.candleDuration}.
        waitUntilCurrentCandleCloses :{" "}
        {candleBreak.waitUntilCurrentCandleCloses ? "true" : "false"}. breakBy :{" "}
        {candleBreak.breakBy}
        <br />
      </>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      border={1}
      {...boxProps}
    >
      <Typography style={{ fontSize: 10 }}>
        {marketOrderText}
        {limitOrderText}
        {candleBreakText}
      </Typography>
    </Box>
  );
}
